import { FC, useCallback, useEffect, useRef, useState } from "react";
import { useRouter } from "next/router";
import { isSoftKey } from 'lib/utils';
import { FieldTypes, KeyboardEvents } from "lib/types";
import { useToastNotification } from "lib/hooks";
import { useToast } from "@chakra-ui/toast";
import { DraftAssetModal } from "../draft-asset";
import { useDisclosure } from "@chakra-ui/react";

let time = null;

export const DraftAssetWrapper: FC = ({ children }) => {
  const toastIdRef = useRef(null);
  const toast = useToast();
  const router = useRouter();
  const { infoToast } = useToastNotification();
  const [ draftValue, setDraftValue ] = useState('');
  const draftAssetModal = useDisclosure();

  const closeToast = useCallback(() => {
    if (!toastIdRef?.current) return;
    toast.close(toastIdRef.current)
  }, [ toast ]);

  const showToast = useCallback(() => {
    toastIdRef.current = infoToast({
      id: 'typed-notif',
      title: 'Info',
      description: 'Continue typing to add to your pack'
    });
  }, [ infoToast ]);

  const onKeyDown = useCallback((e: any) => {
    resetTimer();

    if (isSoftKey(e) || e.target.nodeName === 'INPUT' || e.target.nodeName === 'TEXTAREA') {
      return;
    }

    setDraftValue((prev) => prev + e.key);

    if (!toast.isActive('typed-notif') && !draftValue.length) {
      showToast();
    }
  }, [draftValue.length, toast, setDraftValue, showToast]);

  const resetTimer = (cancel?: boolean) => {
    clearTimeout(time);
    if (cancel) return;
    time = setTimeout(() => setDraftValue(''), 5000);
  };

  useEffect(() => {
    if (draftValue?.length < 4 || draftAssetModal.isOpen) {
      return;
    }

    closeToast();
    resetTimer(true);

    draftAssetModal.onOpen();
  }, [setDraftValue, draftValue, closeToast, draftAssetModal]);

  useEffect(() => {
    if (draftAssetModal.isOpen) {
      document.removeEventListener(KeyboardEvents.KEYDOWN, onKeyDown, false);
      return;
    }

    document.addEventListener(KeyboardEvents.KEYDOWN, onKeyDown, false);

    return () => {
      document.removeEventListener(KeyboardEvents.KEYDOWN, onKeyDown, false);
    }
  }, [draftAssetModal.isOpen, onKeyDown, router]);

  const handleClose = () => {
    setDraftValue(() => '');
    draftAssetModal.onClose();
  }

  return (
    <>
      { children }
      <DraftAssetModal
        isOpen={draftAssetModal.isOpen}
        asset={{ type: FieldTypes.UNKNOWN, value: draftValue }}
        onClose={handleClose}
      />
    </>
  )
}
